import { normalizeGQLResponse } from "../utils/normalizeGQLResponse";
const SHOPIFY_STOREFRONT_TOKEN = document.getElementById('customer-email').dataset.token;
const SHOPIFY_STOREFRONT_GRAPHQL = `https://${window.location.hostname}/api/2023-07/graphql.json`;

const loginQuery = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors { code message }
      }
    }
`;

async function graphqlRequest(query, variables) {
    return new Promise((resolve, reject) => {
      fetch(SHOPIFY_STOREFRONT_GRAPHQL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN,
        },
        body: JSON.stringify({
          query: query,
          variables: variables,
        }),
      })
          .then((res) => res.json())
          .then((data) => resolve(normalizeGQLResponse(data)))
          .catch((error) => reject(error));
    });
}

async function loginCustomer({ email, password }) {
    const data = await graphqlRequest(loginQuery, {
        input: { email, password },
    });
    return data;
}

const loginFunction = () => {
    const loginForms = document.querySelectorAll('#customer_login');

    loginForms.forEach((loginForm) => {
        const loginEmail = loginForm?.querySelector('input[name="customer[email]"]');
        const loginPassword = loginForm?.querySelector(
            'input[name="customer[password]"]'
        );
        loginForm?.addEventListener("submit", (e) => {
          e.preventDefault();
          e.stopPropagation();
          loginCustomer({
            email: loginEmail.value,
            password: loginPassword.value,
          }).then( (res) => {
            if (res.customerAccessTokenCreate.customerUserErrors.length < 1) {
              const accessToken =
                  res.customerAccessTokenCreate.customerAccessToken.accessToken;
              window.localStorage.setItem("ShopifyCustomerToken", accessToken);
            } else {
              window.localStorage.setItem("ShopifyCustomerToken", "");
            }
            loginForm.submit();
          })
        }, true);
    })
}

const registerQuery = `
    mutation customerCreate($input: CustomerCreateInput!) {
      customerCreate(input: $input) {
        customer {
          id
          email
        }
        customerUserErrors {
          code
          message
        }
      }
    }
`;

async function registerCustomer({ email, password, firstName, lastName }) {
    const data = await graphqlRequest(registerQuery, {
        input: { email, password, firstName, lastName },
    });

    if (data.customerCreate.customerUserErrors.length < 1) {
        const loginData = await loginCustomer({ email, password });
        if (loginData.customerAccessTokenCreate.customerUserErrors.length < 1) {
            const accessToken = loginData.customerAccessTokenCreate.customerAccessToken.accessToken;
            return accessToken;
        } else {
            console.error("Login failed after registration:", loginData.customerAccessTokenCreate.customerUserErrors);
            throw new Error("Login failed after registration.");
        }
    } else {
        console.error("Registration failed:", data.customerCreate.customerUserErrors);
        throw new Error("Registration failed.");
    }
}

const registerFunction = () => {
    const registerForms = document.querySelectorAll('#customer_register');

    registerForms.forEach((registerForm) => {
        const registerEmail = registerForm?.querySelector('input[name="customer[email]"]');
        const registerPassword = registerForm?.querySelector('input[name="customer[password]"]');
        const registerFirstName = registerForm?.querySelector('input[name="customer[first_name]"]');
        const registerLastName = registerForm?.querySelector('input[name="customer[last_name]"]');

        registerForm?.addEventListener("submit", (e) => {
            e.preventDefault();
            e.stopPropagation();

            registerCustomer({
                email: registerEmail.value,
                password: registerPassword.value,
                firstName: registerFirstName.value,
                lastName: registerLastName.value,
            }).then((accessToken) => {
                if (accessToken) {
                    window.localStorage.setItem("ShopifyCustomerToken", accessToken);
                    registerForm.submit();
                } else {
                    console.error("Access Token is missing.");
                    window.localStorage.setItem("ShopifyCustomerToken", "");
                }
            }).catch((error) => {
                console.error("Error during registration or login:", error.message);
                window.localStorage.setItem("ShopifyCustomerToken", "");
            });
        }, true);
    });
};

export {loginFunction, registerFunction};